import React from "react";
import { Col, Row } from "@themesberg/react-bootstrap";
import { ProductEditComponent } from "../components/ProductEditComponent";

export default function ProductEdit() {
  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <h4>Edit Product</h4>
      </div>
      <Row className="mb-5">
        <Col xs={12} xl={12}>
          <ProductEditComponent />
        </Col>
      </Row>
    </>
  );
}
